var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAuthFooterDeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 23,
    viewBox: "0 0 4 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 8.89543 0.895431 8 2 8V8C3.10457 8 4 8.89543 4 10V13C4 14.1046 3.10457 15 2 15V15C0.895431 15 0 14.1046 0 13V10Z",
    fill: "#DD0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 16.8954 0.895431 16 2 16V16C3.10457 16 4 16.8954 4 18V21C4 22.1046 3.10457 23 2 23V23C0.895431 23 0 22.1046 0 21V18Z",
    fill: "#FFCE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0V0C3.10457 0 4 0.895431 4 2V5C4 6.10457 3.10457 7 2 7V7C0.895431 7 0 6.10457 0 5V2Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0V0C3.10457 0 4 0.895431 4 2V5C4 6.10457 3.10457 7 2 7V7C0.895431 7 0 6.10457 0 5V2Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0V0C3.10457 0 4 0.895431 4 2V5C4 6.10457 3.10457 7 2 7V7C0.895431 7 0 6.10457 0 5V2Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuthFooterDeDots);
export default __webpack_public_path__ + "static/media/icon_auth_footer_de_dots.544a35ed2809d33b1219d4a353eb998e.svg";
export { ForwardRef as ReactComponent };